export const environment = {
  name: 'dev',
  configFile: '/assets/config/config.dev.json',
};
